import { render, staticRenderFns } from "./quienes_somos.vue?vue&type=template&id=43f093fc&scoped=true&"
import script from "./quienes_somos.vue?vue&type=script&lang=js&"
export * from "./quienes_somos.vue?vue&type=script&lang=js&"
import style0 from "./quienes_somos.vue?vue&type=style&index=0&id=43f093fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f093fc",
  null
  
)

export default component.exports